import { render, staticRenderFns } from "./publicityDetail.vue?vue&type=template&id=a43b4e82"
import script from "./publicityDetail.vue?vue&type=script&lang=js"
export * from "./publicityDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports